// FOR LOCAL SERVER
// const baseUrl: string = 'http://139.84.175.8:9001'
// export const pythonUrl: string = 'http://192.168.1.91:8000'
// export const domain: string = 'http://139.84.175.8'
// ===============================================================
// .
// FOR TEST SERVER
// New Test server Domain.
const baseUrl: string = 'https://tool.lawttorney.com'
// export const pythonUrl: string = 'http://139.84.175.8'
export const pythonUrl: string = 'https://tool.lawttorney.com'
export const domain: string = 'https://tool.lawttorney.com'
// .
// .
// .
// .NEW TEST SERVER by ZEESHAN SIR
// const baseUrl: string = 'http://64.176.97.182:9001'
// export const pythonUrl: string = 'http://64.176.97.182:5000'
// export const domain: string = 'http://64.176.97.182'
// // .
// .
// const baseUrl: string = 'http://139.84.175.8:9001'
// // export const pythonUrl: string = 'http://139.84.175.8'
// export const pythonUrl: string = 'http://64.176.97.182:5000'
// export const domain: string = 'http://139.84.175.8'
// .
// .
// .
// ===============================================================
// .
// FOR MAIN SERVER
// .
// const baseUrl: string = 'https://lawttorney.ai'
// export const pythonUrl: string = 'https://lawttorney.ai'
// export const domain: string = 'https://lawttorney.ai'
// .
// .
// .
export default baseUrl
